import { useOutletContext } from 'react-router-dom';
import { ErrorPageLayout, PaperLayout } from '../../../../presentation';
import { useConvergeNavigation } from '../../../../contexts';
import { GetBrokerAgencyEntityQuery } from '@converge/graphql';
import { BrokerAgencyEntityPageContainer } from '../broker-agency-entity.page.container';
import { useCallback } from 'react';
import { BrokerAgencyEntityDetailPageSlug } from '@converge/data';
import './broker-agencies-entity.detail.overview.scss';

interface IProps {
  brokerAgencyEntity: GetBrokerAgencyEntityQuery;
}

export const BrokerAgencyDetailOverview = () => {
  const { brokerAgencyEntity } = useOutletContext<IProps>();
  if (!brokerAgencyEntity) {
    return (
      <ErrorPageLayout
        message="No broker agency data found"
        messageId="entity.broker-agency.detail.page.NotFound"
      />
    );
  }

  return <BrokerAgencyEntityDetailOverviewInner data={brokerAgencyEntity} />;
};

export const BrokerAgencyEntityDetailOverviewInner = ({
  data,
}: {
  data: GetBrokerAgencyEntityQuery;
}) => {
  const navigate = useConvergeNavigation();

  const navigateToQuotes = useCallback(() => {
    navigate.brokerAgencyEntityDetail({
      brokerAgencyUuid: data?.entity?.uuid as string,
      sectionUrl: BrokerAgencyEntityDetailPageSlug.Agents,
    });
  }, [data, navigate]);

  return (
    <BrokerAgencyEntityPageContainer
      title="Overview"
      onNext={() => navigateToQuotes()}
    >
      <PaperLayout className="broker-agency-entity-layout">
        <p>TBD org structure</p>
      </PaperLayout>
    </BrokerAgencyEntityPageContainer>
  );
};
